export default __webpack_public_path__ + "static/media/SqlServer.75d22895.svg";